import classNames from "classnames";
import * as React from "react";
// import store from "~/store";
// import { addToBasketRequest } from "~/store/reducers/basket/basket-actions";
import Anchor from "../anchor/anchor";
import ArrowLink from "../arrow-link/arrow-link";

export interface IPaperEmbedProps {
    richText: string;
    addToBasketWebApiUrl: string;
    anchorId?: string;
    pdfLink?: string;
}

const IPaperEmbed: React.FC<IPaperEmbedProps> = ({ richText, anchorId, pdfLink }) => {
    const handlePostMessage = ({ data }: MessageEvent) => {
        if (data.event !== "onItemAdd") {
            return;
        }

        // The data structure below is dictated by the postMessage event generated by the iPaper API and can therefore not be changed
        // const articleId: string = data.data.productID;

        // if (articleId) {
        //     store.dispatch(
        //         addToBasketRequest({
        //             articleId,
        //             basketWebApiUrl: addToBasketWebApiUrl,
        //             trackingList: "iPaper Embed"
        //         })
        //     );
        // }
    };

    React.useEffect(() => {
        if (window.hasMessageListener) {
            return;
        }

        window.addEventListener("message", handlePostMessage);
        window.hasMessageListener = true;

        return () => {
            window.removeEventListener("message", handlePostMessage);
            delete window.hasMessageListener;
        };
    }, []);

    const baseClass = "ipaper-embed";
    const componentClasses = classNames(baseClass, {
        "anchor-wrapper": !!anchorId
    });

    return (
        <section className={componentClasses}>
            {anchorId && <Anchor id={anchorId} />}
            <div className={`${baseClass}__inner`} dangerouslySetInnerHTML={{ __html: richText }} />
            {pdfLink && <ArrowLink className={`${baseClass}__pdf-link`} link={pdfLink} />}
        </section>
    );
};

export default IPaperEmbed;
